<template>
  <div>
    <div v-if="logs.length === 0">
      暂无数据
    </div>
    <div v-else>
      <el-timeline :reverse="reverse">
        <el-timeline-item
          v-for="(activity, index) in logs"
          :key="index"
          :timestamp="activity.soperaTime">
          <span v-if="activity.btype === 1">{{ activity.sopera + ':创建' }}</span>
          <span v-else-if="activity.btype === 2">{{ activity.sopera + ':修改' }}</span>
          <span v-else-if="activity.btype === 3">{{ activity.sopera + ':出货' }}</span>
          <span v-else-if="activity.btype === 4">{{ activity.sopera + ':改单' }}</span>
          <span v-else-if="activity.btype === 5">{{ activity.sopera + ':取消' }}</span>
          <span v-else-if="activity.btype === 6">{{ activity.sopera + ':退回' }}</span>
          <span v-else-if="activity.btype === 7">{{ activity.sopera + ':核销' }}</span>
          <span v-else-if="activity.btype === 8">{{ activity.sopera + ':删除' }}</span>
          <span v-else-if="activity.btype === 9">{{ activity.sopera + ':到店无货' }}</span>
          <span v-else-if="activity.btype === 10">{{ activity.sopera + ':下架' }}</span>
          <span v-else>{{ activity.sopera + ':未知操作' }}</span>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
export default {
  name: "PickingChangeChoose",
  props: {
    pickId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      logs: [],
      reverse: true,
    };
  },
  mounted() {
    this.topsAjax.get(`${this.baseUrls.ordPicking}/queryPickLog`, { pickId: this.pickId }).then((res) => {
      this.logs = res;
    });
  }
};
</script>

<style lang="scss">
.el-popover__title {
  text-align: center;
}

.input145px {
  .el-input {
    width: 145px !important;
  }
}
</style>
<style lang="scss" scoped>
.el-descriptions-item__content > p {
  color: black;
}

.el-form-item {
  margin-bottom: 0;
}

.el-form-item__content {
  display: block;
}

.delivery-platform-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.remaining-time {
  color: green;
}

.overdue-time {
  color: red;
}

.delivery-block {
  height: 70px;
  width: 20%;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.hover-color:hover {
  /* 鼠标悬停时的样式 */
  background-color: rgba(64, 158, 255, 0.21);
}

.active {
  background-color: rgba(64, 158, 255, 0.21);
}
</style>
